import { useBomPartsImportContext } from 'bom/states';
import { FileDropzone } from 'core/components';
import { useStepsContext } from 'core/states';

import { dropzoneStyle, Wrapper } from './style';

const FileUpload = () => {
  const { goToNextStep } = useStepsContext();
  const { acceptFileTypes, setFile } = useBomPartsImportContext();

  const onUpload = (files: File[]) => {
    setFile(files[0]);

    goToNextStep();
  };

  return (
    <Wrapper>
      <FileDropzone accept={acceptFileTypes} onUpload={onUpload} style={dropzoneStyle} />
    </Wrapper>
  );
};

export default FileUpload;
